/* @ngInject */
const myOwnerDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myOwner: '=',
      myContacts: '=?',
      enableButtons: '=?',
      enableBack: '=?',
    },
    template: require('./myOwnerDisplay.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myOwnerDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/directives/display/myOwnerDisplay.js